import React, { useState } from "react";
import "./contactForm.css";
import { send } from "emailjs-com";

const Contact = () => {
  const [toSend, setToSend] = useState({
    from_name: "",
    from_email: "",
    message: "",
  });

  const onSubmit = (e) => {
    e.preventDefault();
    send("service_2hknl4q", "template_56l8m0b", toSend, "wb7M3q4gMF1AOwvEN")
      .then((response) => {
        alert("✨ Message sent successfully");
      })
      .catch((err) => {
        alert("🚨 Message failed to send, please try again");
      });
  };

  const handleChange = (e) => {
    setToSend({ ...toSend, [e.target.name]: e.target.value });
  };

  return (
    <div>
      <div className="contact-container">
        <form className="contactForm" onSubmit={onSubmit}>
          <h1 className="contact-title">Get in Touch</h1>

          <div style={{ textAlign: "center", marginBottom: "1rem" }}>
            <a
              href="mailto:danial@danials.org"
              style={{
                color: "var(--primary-color)",
                textDecoration: "none",
                fontSize: "1.1rem",
                fontWeight: "500",
              }}
              onMouseEnter={(e) =>
                (e.target.style.textDecoration = "underline")
              }
              onMouseLeave={(e) => (e.target.style.textDecoration = "none")}
            >
              danial@danials.org
            </a>
          </div>

          <div className="form-group">
            <label>Name</label>
            <input
              type="text"
              name="from_name"
              placeholder="Enter your name"
              value={toSend.from_name}
              onChange={handleChange}
            />
          </div>

          <div className="form-group">
            <label>Email address</label>
            <input
              type="email"
              name="from_email"
              placeholder="Enter your email"
              value={toSend.from_email}
              onChange={handleChange}
            />
          </div>

          <div className="form-group">
            <label>Message</label>
            <textarea
              name="message"
              placeholder="Type your message here..."
              value={toSend.message}
              onChange={handleChange}
            />
          </div>

          <button type="submit">Send Message</button>
        </form>
      </div>
      {/* <div className="contact-container">
        <div
          style={{
            marginTop: "1rem",
            marginBottom: "1rem",
            // paddingTop: "1rem",
            // borderTop: "1px solid rgba(255, 255, 255, 0.1)",
            textAlign: "center",
          }}
        >
          <h3 style={{ marginBottom: "1rem", color: "var(--text-color)" }}>
            Or support with Monero
          </h3>
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              gap: "1rem",
            }}
          >
            <img
              src="/qrcode.png"
              alt="Monero Wallet QR Code"
              style={{
                maxWidth: "200px",
                height: "auto",
                borderRadius: "10px",
                border: "1px solid rgba(255, 255, 255, 0.2)",
              }}
            />
            <div
              style={{
                padding: "0.75rem",
                backgroundColor: "rgba(255, 255, 255, 0.05)",
                borderRadius: "8px",
                fontFamily: "monospace",
                fontSize: "0.9rem",
                wordBreak: "break-all",
                border: "1px solid rgba(255, 255, 255, 0.1)",
                position: "relative",
                cursor: "pointer",
              }}
              title="Click to copy Monero wallet address"
              onClick={() => {
                const address =
                  "8B5RVmzPgFshB9fXRbUgQ56CGXzgrw4aq5KoTPkZEJFiLQ7skxj5PSnN2okJM1vzX7jp64wpuAHPBETF3DPPV8xWGDmR6RR";
                if (navigator && navigator.clipboard) {
                  navigator.clipboard.writeText(address).then(
                    () => {
                      alert("Monero wallet address copied to clipboard!");
                    },
                    () => {
                      alert("Failed to copy address. Please copy manually.");
                    }
                  );
                } else {
                  // fallback for older browsers
                  const textArea = document.createElement("textarea");
                  textArea.value = address;
                  document.body.appendChild(textArea);
                  textArea.focus();
                  textArea.select();
                  try {
                    document.execCommand("copy");
                    alert("Monero wallet address copied to clipboard!");
                  } catch (err) {
                    alert("Failed to copy address. Please copy manually.");
                  }
                  document.body.removeChild(textArea);
                }
              }}
            >
              <div style={{ marginBottom: "0.5rem", opacity: 0.7 }}>
                Monero Wallet:
              </div>
              <div
                style={{
                  color: "var(--primary-color)",
                  display: "flex",
                  alignItems: "center",
                  gap: "0.5rem",
                  justifyContent: "center",
                  userSelect: "all",
                }}
              >
                <span id="wallet-address">
                  8B5RVmzPgFshB9fXRbUgQ56CGXzgrw4aq5KoTPkZEJFiLQ7skxj5PSnN2okJM1vzX7jp64wpuAHPBETF3DPPV8xWGDmR6RR
                </span>
              </div>
            </div>
          </div>
        </div>
      </div> */}
    </div>
  );
};

export default Contact;
